var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Nav / Stock / no notification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Nav-/-Stock-/-no-notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stock",
    transform: "translate(22.000000, 23.000000)",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#3C434D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shelf",
    transform: "translate(0.450001, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    points: "0.5 13.5 0.5 1 0.5 18.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,1 L18.4123607,1",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,8 L18.4123607,8",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,15 L18.4123607,15",
    id: "Line"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    points: "18.3999977 13.5 18.3999977 1 18.3999977 18.5"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Spacer-square",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/Stock.23f87cb52cbfa9b78d688b6476143663.svg";
export { ForwardRef as ReactComponent };